module.exports = __webpack_public_path__ + "img/layer_edit.4e13eebf.jpg";